import { createSelector } from "reselect";
import { RootState } from "../../state";

export const companyFollowingSelector = createSelector(
  (_state: RootState, props: { companyId: number }) => props.companyId,
  (state: RootState) => state.company_followings.followings,
  (companyId, followings) => followings![companyId]
);



// WEBPACK FOOTER //
// ./frontend/src/company_followings/selectors/index.ts